module.exports = __webpack_public_path__ + "img/trash-hard.788b74ac.svg";